import { DefList, DefRow, IntakeStatus, PortalSection } from "./portal-ui";
import { formatPortalDate, intakeState } from "./portal-utils";

interface ApplicationDeadlineCardProps {
  startDate?: string | Date;
  endDate?: string | Date;
  /** Cheque range, already formatted, when known. */
  capital?: string | null;
  /** What kind of programme this is (Accelerator, Fund…). */
  type?: string;
  locations?: string[];
}

/**
 * "At a glance": the facts a founder checks before reading anything else
 * (whether applications are open, the dates, the cheque, where and what) as
 * one definition list on paper. The close date also leads the cover; this is
 * where it sits with everything around it.
 */
export function ApplicationDeadlineCard({
  startDate,
  endDate,
  capital,
  type,
  locations,
}: ApplicationDeadlineCardProps) {
  const state = intakeState(startDate, endDate);
  const opens = formatPortalDate(startDate);
  const closes = formatPortalDate(endDate);
  const where = (locations ?? []).filter(Boolean);

  return (
    <PortalSection title="At a glance">
      <DefList>
        <DefRow term="Status">
          <IntakeStatus state={state} className="text-[15px]" />
        </DefRow>
        {opens && (
          <DefRow term={state === "upcoming" ? "Opens" : "Opened"}>
            <span className="tabular-nums">{opens}</span>
          </DefRow>
        )}
        <DefRow term={state === "closed" ? "Closed" : "Closes"}>
          {closes ? (
            <span className="tabular-nums">{closes}</span>
          ) : (
            <span className="text-muted-foreground">
              Rolling. Applications are reviewed as they arrive.
            </span>
          )}
        </DefRow>
        {capital && (
          <DefRow term="Cheque size">
            <span className="font-medium tabular-nums">{capital}</span>
          </DefRow>
        )}
        {type && <DefRow term="Programme">{type}</DefRow>}
        {where.length > 0 && <DefRow term="Where">{where.join(", ")}</DefRow>}
      </DefList>
    </PortalSection>
  );
}
